// extracted by mini-css-extract-plugin
export default {"Root":"Header_Root__7luyv","FilterBtn":"Header_FilterBtn__H7tZ8","Title":"Header_Title__msFle","Description":"Header_Description__-2C3D"};